<template>
  <fa :icon="value ? 'check' : 'times'" :class="value ? 'text-success' : 'text-muted'" />
</template>

<style scoped>
.custom-control-label::after {
  top: 0.1rem;
}

.custom-control-label::before {
  top: 0.1rem;
}
</style>

<script>
export default {
  name: 'CheckMark',

  props: {
    value: { type: [ Boolean, Number ], default: false },
  },
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/CheckMark.vue